module.exports = "https://static.operabase.net/ff5588df-049a-48c9-8f6f-be872a35c364/_next/static/images/bitmap-629d21b2a0fc6f254c69ea637037f10b.jpg";